import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

import { Card, Grid } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default class RequestDemoList extends Component {
  state = {
    demos: [],
    pagination: {
      page: 1,
      totalpage: 1,
      nextpage: false,
      prevpage: false,
      total: 0,
      limit: 10,
    },
    per_page: 10,
    page_no: 1,
    loading: false,

    notification: false,
    notiColor: "success",
    message: "",
  };

  componentDidMount() {
    this.getAllDemoRequests(this.state.page_no, this.state.per_page);
  }

  // ================= GET LIST =================
  getAllDemoRequests = (page = 1, limit = 10) => {
    this.setState({ loading: true });

    if (init() !== "success") {
      this.setState({ loading: false });
      return window.location.assign("/signin");
    }

    axios
      .get(`${Constants.getUrls.getRequestDemo}?page=${page}&limit=${limit}`)
      .then((resp) => {
        const data = resp.data?.data || [];
        const pg = resp.data?.pagination || {};

        this.setState({
          demos: Array.isArray(data) ? data : [],
          pagination: pg,
          page_no: page,
          per_page: limit,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Failed to load demo requests",
          loading: false,
        });
        setTimeout(() => {
          this.setState({
            notification: false,
            message: "",
            notiColor: "success",
          });
        }, 3500);
      });
  };

  handlePageChange = (newPage) => {
    this.getAllDemoRequests(newPage, this.state.per_page);
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.getAllDemoRequests(1, newLimit);
  };

  // ================= DELETE =================
  handleDelete = (id) => {
    if (!window.confirm("Delete this demo request?")) return;

    if (init() !== "success") {
      return window.location.assign("/signin");
    }

    axios
      .delete(Constants.deleteUrls.deleteRequestDemo + id)
      .then((resp) => {
        this.setState(
          {
            notification: true,
            notiColor: "success",
            message: resp.data?.message || "Demo request deleted",
          },
          () => {
            this.getAllDemoRequests(this.state.page_no, this.state.per_page);
          }
        );
        setTimeout(() => this.setState({ notification: false, message: "" }), 2500);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Failed to delete demo request",
        });
        setTimeout(() => this.setState({ notification: false, message: "" }), 3500);
      });
  };

  // ---------------- Gmail compose helpers ----------------
  encodeForQuery = (str = "") => {
    const normalized = String(str).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    return encodeURIComponent(normalized);
  };

  buildGmailComposeUrl = ({ to = "", subject = "", body = "", cc = "", bcc = "" }) => {
    const base = "https://mail.google.com/mail/?view=cm&tf=1";
    const params = [];

    if (to) params.push(`to=${this.encodeForQuery(to)}`);
    if (cc) params.push(`cc=${this.encodeForQuery(cc)}`);
    if (bcc) params.push(`bcc=${this.encodeForQuery(bcc)}`);
    if (subject) params.push(`su=${this.encodeForQuery(subject)}`);
    if (body) params.push(`body=${this.encodeForQuery(body)}`);

    return `${base}&${params.join("&")}`;
  };

  openGmailCompose = (enquiry) => {
    if (!enquiry) return;

    const to = enquiry.email || enquiry.contact_email || "";
    const subject = `Response to your enquiry`;
    const body = `Hi ${
      enquiry.contact_person_name || enquiry.name || ""
    },\n\nThank you for reaching out. We received your enquiry and will contact you shortly.\n\nYour message:\n${
      enquiry.message || ""
    }\n\nRegards,\nYour Team`;

    const gmailUrl = this.buildGmailComposeUrl({ to, subject, body });

    try {
      window.open(gmailUrl, "_blank", "noopener,noreferrer");
    } catch (err) {
      const mailto = `mailto:${encodeURIComponent(to)}?subject=${this.encodeForQuery(
        subject
      )}&body=${this.encodeForQuery(body)}`;
      window.open(mailto, "_blank", "noopener,noreferrer");
    }
  };

  // ================= RENDER =================
  render() {
    const { demos, loading, pagination } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Demo Requests
              </MDTypography>
            </MDBox>

            <MDBox py={3}>
              {loading ? (
                <Grid align="center">
                  <h4>Loading...</h4>
                </Grid>
              ) : demos.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "#", accessor: "serial", width: "6%" },
                      { Header: "Student", accessor: "student_name" },
                      { Header: "Guardian", accessor: "guardian_name" },
                      { Header: "Email", accessor: "email" },
                      { Header: "Contact", accessor: "contact" },
                      { Header: "Age", accessor: "age" },
                      { Header: "Date", accessor: "date" },
                      { Header: "Status", accessor: "status" },
                      { Header: "Action", accessor: "action" },
                    ],
                    rows: demos.map((item, index) => {
                      const page = pagination.page || 1;
                      const limit = pagination.limit || this.state.per_page;
                      const serial = (page - 1) * limit + (index + 1);

                      return {
                        serial,
                        student_name: item.student_name || "-",
                        guardian_name: item.guardian_name || "-",
                        email:
                          (
                            <span
                              style={{
                                color: "#1a73e8",
                                cursor: "pointer",
                                textDecoration: "underline",
                              }}
                              onClick={() => this.openGmailCompose(item)}
                            >
                              {item.email}
                            </span>
                          ) || "-",
                        contact: item.contact || "-",
                        age: item.age || "-",
                        date: item.date ? new Date(item.date).toLocaleDateString() : "-",
                        status: item.status || "new",
                        action: (
                          <MDButton
                            variant="outlined"
                            size="small"
                            color="error"
                            onClick={() => this.handleDelete(item._id)}
                          >
                            Delete
                          </MDButton>
                        ),
                      };
                    }),
                  }}
                  entriesPerPage={{
                    defaultValue: this.state.per_page,
                  }}
                  page_no={pagination.page}
                  totalPages={pagination.totalpage}
                  hasNextPage={pagination.nextpage}
                  hasPrevPage={pagination.prevpage}
                  onPageChange={this.handlePageChange}
                  onEntriesPerPageChange={this.handleEntriesPerPageChange}
                />
              ) : (
                <div style={{ padding: 16 }}>No Demo Requests Found!</div>
              )}
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="VASA | Demo Requests"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
